import { Component, EventEmitter, Input, Output } from '@angular/core';
import { UiModule } from '../ui';


@Component({
    selector: 'comparables-controls',
    imports: [
        UiModule,
    ],
    styles: [
        `
        .btn-toolbar > :not(:first-child) {
            margin-left: .25rem;
        }
        .btn-toolbar > :not(:last-child) {
            margin-right: .25rem;
        }
        `,
    ],
    template: `
        <div class="btn-toolbar print-hidden" role="toolbar">
            <div class="btn-group" role="group">
                <button type="button" class="btn btn-secondary" (click)="customizeColumns.emit()">
                    <i class="fa fa-columns"></i>
                    Customize Columns
                </button>
            </div>
            @if (showDownload) {
                <div class="btn-group" role="group">
                    <button class="btn btn-secondary" [loading]="loading" [disabled]="loading" (click)="download.emit()">
                        Download Full Listings
                    </button>
                </div>
            }
            <div class="btn-group" role="group">
                <button class="btn btn-secondary" (click)="export.emit()">
                    Export Selected to CSV
                </button>
            </div>
            <div class="btn-group" role="group">
                <button
                    class="btn btn-secondary"
                    [disabled]="basemapKey == 'esri-aerial'"
                    (click)="basemapKeyChange.emit('esri-aerial')">
                    Aerial View
                </button>
                <button
                    class="btn btn-secondary"
                    [disabled]="basemapKey == 'esri-road'"
                    (click)="basemapKeyChange.emit('esri-road')">
                    Road View
                </button>
            </div>
            <div class="btn-group" role="group">
                <button
                    class="btn btn-secondary"
                    title="Click to increase font size of the table"
                    [disabled]="fontSize >= fontSizeMax"
                    (click)="incFontSize()">
                    A <i class="fa fa-plus"></i>
                </button>
                <button
                    class="btn btn-secondary"
                    title="Click to decrease font size of the table"
                    [disabled]="fontSize <= fontSizeMin"
                    (click)="decFontSize()">
                    A <i class="fa fa-minus"></i>
                </button>
            </div>
        </div>
    `,
})
export class ComparablesControlsComponent {

    @Input() showDownload = false;

    @Input() fontSize: number;

    @Output() fontSizeChange = new EventEmitter<number>();

    fontSizeMax = 14;

    fontSizeMin = 6;

    @Input() basemapKey: string;

    @Output() basemapKeyChange = new EventEmitter<string>();

    @Output() download = new EventEmitter();

    @Output() export = new EventEmitter();

    @Output() customizeColumns = new EventEmitter();

    @Input() loading = false;

    incFontSize() {
        if (this.fontSize >= this.fontSizeMax) {
            return;
        }
        this.fontSizeChange.emit(this.fontSize + 1);
    }

    decFontSize() {
        if (this.fontSize <= this.fontSizeMin) {
            return;
        }
        this.fontSizeChange.emit(this.fontSize - 1);
    }
}
